import React from "react"
import { IPayrollPayCalendar } from "../../models"
import { SelectField, MenuItem } from "material-ui"
import strings from "../../localization/strings"
import * as payrollHelper from "../../helpers/payrollHelper"

interface IProps {
    width?: number
    selectedPayrollPayCalendar: IPayrollPayCalendar
    handleSelect(selectedPayrollPayCalendar: IPayrollPayCalendar): void
}

const PayCalendarSelector: React.SFC<IProps> = (props: IProps) => {
    const validPayrollPayCalendars = payrollHelper.getValidPayrollPayCalendars()
    return validPayrollPayCalendars && validPayrollPayCalendars.length > 1 &&
        <SelectField
            autoWidth
            data-intercom-target={"Payroll-Select-PayrollPayCalendar"}
            floatingLabelText={strings.Pay_Calendars}
            value={props.selectedPayrollPayCalendar.PayCalendarLabel}
            style={{ width: props.width || 300 }}
            onChange={(event, key, payload) => {
                localStorage.setItem("findd_selected_payroll_pay_calendar_label", payload)
                props.handleSelect(validPayrollPayCalendars.find(i => i.PayCalendarLabel === payload))
            }}
            title={props.selectedPayrollPayCalendar.PayCalendarLabel}
        >
            {validPayrollPayCalendars.map((payCalendar, key) =>
                <MenuItem
                    key={key}
                    value={payCalendar.PayCalendarLabel}
                    primaryText={payCalendar.PayCalendarLabel}
                />
            )}
        </SelectField>
}

export default PayCalendarSelector